import { requestConstantsMaker } from '../helper';

export const GET_ALL_EMAIL_RECORD_BY_SPECIFICATION = requestConstantsMaker('GET_ALL_EMAIL_RECORD_BY_SPECIFICATION');